import React from 'react';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { CurrencyFormatter } from '../CurrencyFormatter';
import { commonTransferStyles } from './Common.style';
import { transferSummaryStyles } from './PaymentSummary.style';
export const PaymentSummary = ({ lines }) => {
    const commonTransferClasses = commonTransferStyles();
    const transferSummaryClasses = transferSummaryStyles();
    const commonTextNormal = Object.assign(Object.assign({}, commonTransferClasses.commonText), commonTransferClasses.commonTextNormal);
    const commonTextBold = Object.assign(Object.assign(Object.assign({}, commonTransferClasses.commonText), commonTransferClasses.commonTextBold), transferSummaryClasses.textBold);
    const SummaryLine = ({ label, amount, isBold }) => {
        return (React.createElement(Box, { sx: transferSummaryClasses.dialogTitle },
            React.createElement(Typography, { sx: isBold ? commonTextBold : commonTextNormal }, label),
            React.createElement(Typography, { sx: commonTextNormal },
                React.createElement(CurrencyFormatter, { amount: amount, withCurrencySymbol: true, minimumFractionDigits: 2 }))));
    };
    return (React.createElement(Box, { sx: commonTransferClasses.commonContentContainer },
        React.createElement(Stack, { sx: transferSummaryClasses.stackStyle }, lines.map((item, index) => (React.createElement(Box, { key: `item-${index}` },
            React.createElement(SummaryLine, Object.assign({}, item))))))));
};
